import { DateTime } from "luxon";

const chartData = (
  dataArray,
  key,
  initialDate,
  { valueModifier = (v) => v, serviceKey = null, range = { days: 6 } } = {}
) => {
  const startIndex = dataArray.findIndex(
    (v) => v.datetime === DateTime.fromISO(initialDate, { zone: "utc" }).toISO()
  );
  const endIndex = dataArray.findIndex(
    (v) => v.datetime === DateTime.fromISO(initialDate, { zone: "utc" }).plus(range).toISO()
  );
  const data = { x: [], y: [] };
  dataArray.slice(startIndex, endIndex).forEach((entry) => {
    data.x.push(entry.datetime);
    if (serviceKey) {
      data.y.push(valueModifier(entry[serviceKey] ? entry[serviceKey][key] || 0 : 0));
    } else {
      data.y.push(valueModifier(entry[key]));
    }
  });
  return data;
};

const powerNominationData = (dataArray, service, initialDate) => {
  const charge = chartData(dataArray, "consumption", initialDate, {
    serviceKey: service,
    valueModifier: (v) => v * -1,
  });
  const discharge = chartData(dataArray, "generation", initialDate, {
    serviceKey: service,
  });
  // eslint-disable-next-line no-restricted-globals
  return charge.y.every((v) => !Number.isNaN(v)) && discharge.y.every((v) => !Number.isNaN(v))
    ? { x: charge.x, y: charge.y.map((val, i) => val + discharge.y[i]) }
    : { x: [], y: [] };
};

const getReserveChartData = (
  dataArray,
  reserveKey,
  key,
  initialDate,
  { valueModifier = (v) => v, range = { days: 6 } } = {}
) => {
  const startIndex = dataArray.findIndex(
    (v) => v.datetime === DateTime.fromISO(initialDate, { zone: "utc" }).toISO()
  );
  const endIndex = dataArray.findIndex(
    (v) => v.datetime === DateTime.fromISO(initialDate, { zone: "utc" }).plus(range).toISO()
  );
  const data = { x: [], y: [] };
  dataArray.slice(startIndex, endIndex).forEach((entry) => {
    data.x.push(entry.datetime);
    data.y.push(valueModifier(entry.R[reserveKey][key]));
  });
  return data;
};

const reservePowerNominationData = (dataArray, reserveKey, initialDate) => {
  const charge = getReserveChartData(dataArray, reserveKey, "consumption", initialDate, {
    valueModifier: (v) => v * -1,
  });
  const discharge = getReserveChartData(dataArray, reserveKey, "generation", initialDate);
  return charge.y.every((v) => !Number.isNaN(v)) && discharge.y.every((v) => !Number.isNaN(v))
    ? { x: charge.x, y: charge.y.map((val, i) => val + discharge.y[i]) }
    : { x: [], y: [] };
};

export { powerNominationData, reservePowerNominationData, chartData };
